import { apiClient } from './api-client';
import type { Project, ProjectSettings } from '@scrambl/shared';

export const projectSettingsApi = {
  /**
   * Update project settings
   */
  async updateSettings(projectId: string, settings: Partial<ProjectSettings>): Promise<Project> {
    const response = await apiClient<Project>(`/projects/${projectId}/settings`, {
      method: 'PUT',
      body: settings,
    });
    return response;
  },

  /**
   * Get project settings
   */
  async getSettings(projectId: string): Promise<ProjectSettings> {
    const response = await apiClient<Project>(`/projects/${projectId}`, {
      method: 'GET',
    });
    return response.settings || {};
  },
};